export default __webpack_public_path__ + "static/media/date.3ec8c9c4.svg";